import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';

export const GET_TENANT_TAXONOMY_QUERY_KEY = 'taxonomy.getTenantTaxonomy';

export const useGetTenantTaxonomy = () => {
  const { getTenantId } = useTenants();
  const { isTaxonomyEnabled } = useFeatureFlags();
  const tenantId = getTenantId();

  const { data, isLoading, error } = useQuery({
    queryKey: [GET_TENANT_TAXONOMY_QUERY_KEY, tenantId],
    queryFn: () => api.taxonomy.listTaxonomies(tenantId),
    select: data => data.data.taxonomies[0],
    enabled: Boolean(tenantId) && isTaxonomyEnabled,
    retry: false,
  });

  return {
    taxonomy: data,
    isLoading,
    error: getApiError(error),
  };
};
